import { render, staticRenderFns } from "./quote-details-view.vue?vue&type=template&id=54a46e3d&scoped=true&"
import script from "./quote-details-view.vue?vue&type=script&lang=js&"
export * from "./quote-details-view.vue?vue&type=script&lang=js&"
import style0 from "./quote-details-view.vue?vue&type=style&index=0&id=54a46e3d&scoped=true&lang=css&"
import style1 from "./quote-details-view.vue?vue&type=style&index=1&id=54a46e3d&lang=scss&scoped=true&"
import style2 from "./quote-details-view.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a46e3d",
  null
  
)

export default component.exports